import { persistentReducedStream, reducer } from '@ardoq/rxbeach';
import {
  activeViewRegistered,
  activeViewUnregistered,
  viewHoldReleased,
  viewHoldTaken,
} from './actions';
import {
  registerView,
  releaseHold,
  takeHold,
  unregisterView,
} from './activeViewsStatusOperations';
import type { ActiveViewsStatus } from './types';

const INITIAL_STATUS: ActiveViewsStatus = {};

export const activeViewsStatus$ = persistentReducedStream(
  'activeViewsStatus$',
  INITIAL_STATUS,
  [
    reducer(activeViewRegistered, registerView),
    reducer(activeViewUnregistered, unregisterView),
    reducer(viewHoldTaken, takeHold),
    reducer(viewHoldReleased, releaseHold),
  ]
);
